import { render, staticRenderFns } from "./DemoOfferSection.vue?vue&type=template&id=646ffefa&scoped=true"
import script from "./DemoOfferSection.vue?vue&type=script&lang=js"
export * from "./DemoOfferSection.vue?vue&type=script&lang=js"
import style0 from "./DemoOfferSection.vue?vue&type=style&index=0&id=646ffefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646ffefa",
  null
  
)

export default component.exports